import { withAppContext } from '@/config/site'
import request from '@/utils/request'

/**
 * 检查章节/小节学习完成状态（用于判断是否弹出考试入口）
 * @param {object} params - 查询参数
 * @param {number} params.course_id - 课程ID
 * @param {number} params.target_type - 目标类型 1=章 2=节
 * @param {number} params.target_id - 章/节ID
 * @returns {Promise<object>} 完成状态和考试信息
 */
export const checkLessonCompletion = async (params) => {
  const response = await request('/page/course/progress/completion-check', {
    data: withAppContext(params)
  })

  return response.data || {}
}

/**
 * 获取课程学习进度概览
 * @param {number} courseId - 课程ID
 * @param {object} payload - 其他参数
 * @returns {Promise<object>} 进度概览数据
 */
export const fetchCourseProgressOverview = async (courseId, payload = {}) => {
  const response = await request('/page/course/progress/overview', {
    data: withAppContext({
      course_id: courseId,
      ...payload
    })
  })

  return response.data || {}
}

/**
 * 获取课程章节维度的学习进度
 * @param {number} courseId - 课程ID
 * @param {object} payload - 其他参数
 * @returns {Promise<object>} 章节进度数据
 */
export const fetchCourseProgressChapter = async (courseId, payload = {}) => {
  const response = await request('/page/course/progress/chapter', {
    data: withAppContext({
      course_id: courseId,
      ...payload
    })
  })

  return response.data || {}
}

/**
 * 更新课时学习进度
 * @param {object} data - 进度数据
 * @param {number} data.lesson_id - 课时ID
 * @param {number} data.progress - 学习进度百分比 0-100
 * @param {number} data.last_position - 上次学习位置(秒)
 * @param {number} data.study_duration - 本次学习时长(秒)
 * @returns {Promise<object>} 更新后的进度数据
 */
export const updateLessonProgress = async (data) => {
  const response = await request('/page/course/progress/update-lesson', {
    data: withAppContext(data)
  })

  return response.data || {}
}

/**
 * 获取课程所有课时的学习进度列表
 * @param {number} courseId - 课程ID
 * @param {object} payload - 其他参数
 * @returns {Promise<array>} 课时进度列表
 */
export const fetchLessonProgressList = async (courseId, payload = {}) => {
  const response = await request('/page/course/progress/lesson-list', {
    data: withAppContext({
      course_id: courseId,
      ...payload
    })
  })

  return Array.isArray(response.data) ? response.data : []
}
